import { TemplateEditPage } from '@features/meeting-templates/components/TemplateEditPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/templates/$id/edit')({ component: TemplateEditPage });
